import React, { FormEvent } from 'react'

import styled from '@emotion/styled'

const Form = styled.form`
  display: flex;
  flex-direction: column;
`

// disable prop spreading for native components
/* eslint-disable react/jsx-props-no-spreading */
export function FormContents({ children, ...props }: React.HTMLAttributes<HTMLFormElement>): React.ReactElement {
  const submitHandler = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault()
    props.onSubmit && props.onSubmit(e)
  }

  return (
    <Form {...props} onSubmit={submitHandler}>
      {children}
    </Form>
  )
}
/* eslint-enable react/jsx-props-no-spreading */
